export default "__VITE_ASSET__BkOTXjyB__"